import {Input} from "antd";
import React, {FC} from "react";
import styles from "@/page-components/verify/Query/styles.module.less";

const QueryInput: FC<{ value?: string, placeholder: string, onChange?: (text: string) => void }> = ({
                                                                                                      value,
                                                                                                      placeholder,
                                                                                                      onChange
                                                                                                    }) => {
  return (
    <div className={styles.query_body_input_item}>
      <Input
        value={value}
        onChange={(e) => {
          onChange?.(e.currentTarget.value);
          //setQueryData((prevState) => ({
          //  ...prevState,
          //  certNo: e.target.value,
          //}));
        }}
        className={styles.query_body_input_item_input}
        placeholder={placeholder}
      />
    </div>
  )
}
export default QueryInput;
